if(!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    constructor() {
      super();
      this.error = this.dataset.error;
      this.errorElement = this.querySelector('.js-error')
      this.success = this.dataset.success;
      this.successElement = this.querySelector('.js-success');
      this.legal = this.querySelector('.js-legal');
      this.legalWrapper = this.querySelector('.js-legal-wrapper');
      this.form = this.querySelector('.js-form');
    }

    handleError() {
      if(!this.errorElement || !this.error) return;

      this.errorElement.innerHTML = this.error;
    }

    handleSuccess() {
      if(this.form) this.form.parentElement.removeChild(this.form);
      if(this.legalWrapper) this.legalWrapper.parentElement.removeChild(this.legalWrapper);
      if(this.errorElement) this.errorElement.innerHTML = '';

      if(!this.success || !this.successElement) return;
      this.successElement.innerHTML = this.success;
    }

    connectedCallback() {
      this.observer = new MutationObserver(() => {
        const button = this.querySelector('button');
        if(!button) return this.handleSuccess();

        // if(!this.legal) return;

        // if(button && !this.legal.checked) button.setAttribute('disabled', 'disabled');
        if(button) button.removeAttribute('disabled');

        if(button) {
          button.parentElement.addEventListener('click', () => {
            const input = this.querySelector('input[type="email"]');
            let isValid = input ? input.value.length > 0 ? true : false : false;

            if(!isValid) return;
      
            // this.handleError();
          });
        }
      });

      this.observer.observe(this, { childList: true, subtree: true });
      
      if(!this.legal) return;

      this.legal.addEventListener('change', () => {
        if(this.legal.checked) {
          const button = this.querySelector('button');

          if(button) button.removeAttribute('disabled');
        } 
      });
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}
